import { render, staticRenderFns } from "./informationFeedbackWX.vue?vue&type=template&id=452c99ac&scoped=true&"
import script from "./informationFeedbackWX.vue?vue&type=script&lang=js&"
export * from "./informationFeedbackWX.vue?vue&type=script&lang=js&"
import style0 from "./informationFeedbackWX.vue?vue&type=style&index=0&id=452c99ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c99ac",
  null
  
)

export default component.exports